module.exports = __webpack_public_path__ + "staticfr/media/paredao_bueno.1030864b.mp4";